import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseApi, BASE_URL } from '@edl-development/edl-common';
import { ProcessUserOnboardingSessionRequest } from '../modals/edl-process-onboarding-request.model';

@Injectable()
export class OnboardingApi extends BaseApi {
    constructor(
        @Inject(BASE_URL) private baseUri: string,
        private http: HttpClient
    ) {
        super();
    }

    getOnboardingList(type:number){
        return this.http.get(this.baseUri + '/Onboarding/' + type, {
            responseType: 'blob'
        });
    }

    uploadOnboardingList(fileList: FileList){
        let file: File = fileList[0];
        let formData: FormData = new FormData();
        formData.append('file', file, file.name);

        return this.http.post(this.baseUri + '/Onboarding/upload', formData);
    }

    getOnboardingSessions(){
        return this.http.get(this.baseUri + '/Onboarding/Sessions');
    }

    getOnboardingSessionUserRequests(sessionId: string, statusId: number, searchBy?:string, offset?:number, limit?:number){

        const params = new HttpParams()
            .append('offset', String(offset))
            .append('limit', String(limit))
            .append('searchBy', this.convertParam(searchBy))
            .append('status', String(statusId));

        statusId = statusId===null? -1 : statusId;

        return this.http.get(this.baseUri + '/Onboarding/Session/UserRequests/'+ sessionId, {
            params
        });
    }

    getOnboardingSessionDetails(sessionId: string){

        return this.http.get(this.baseUri + '/Onboarding/Session/'+ sessionId);
    }

    saveOnboardingSessions(sessionId:string, sessionChanges:any[]){
        return this.http.put(this.baseUri + '/Onboarding/Session/UserRequests/'+sessionId, sessionChanges);
    }

    processOnboardingSession(session:ProcessUserOnboardingSessionRequest){
        return this.http.put(this.baseUri + '/Onboarding/Session/Process', session);
    }
}